export const ROUTES = {
  home: '/',
  newOrder: '/new-order',
  nationwide: '/nationwide',
  // newTruck: '/new-truck',
  truck: '/truck',
  houseMoving: '/house-moving',
  rental: '/rental',
  records: '/records',
  recordDetail: (id: string) => `/record/${id}`,
  verifyOrder: '/verify-order',
  draftOrder: '/draft-order',
  favoriteDrivers: '/favorite-drivers',
  balance: '/balance',
  roTool: '/ro-tool',
  roSme: '/sme/ro-tool',
  ro: '/ro',
  routeOptimizationPickup: '/route-optimization-pickup',
  rewards: '/rewards',
  rewardsByCategory: `/rewards/search`,
  membership: '/membership',
  challenges: '/challenges',
  news: '/news',
  statistics: '/statistics',
  employees: '/employees',
  referral: '/referral',
  warehouse: '/warehouse',
  helpCenter: '/help-center',
  audience: '/audience',
  profile: '/profile',
  auth: {
    login: '/login',
    signup: '/signup',
  },
  sentryExamplePage: '/sentry-example-page',
  payment: {
    transactions: '/payment/transactions',
    transactionDetail: (id: string) => `/payment/transaction/${id}`,
  },
  pay: (id: string) => `/pay/${id}`,
  subscriptions: '/subscriptions',
  subscriptionDetail: (id: string) => `/subscriptions/${id}`,
  mySubscriptionDetail: (id: string) => `/subscriptions/progresses/${id}`,

  suspendedAccount: '/suspended-account',
  checkout: (type: string, id: string | string[]) =>
    `/checkout/${type}/${Array.isArray(id) ? id.join('/') : id}`,
  lookback: {
    driver: '/lookback/driver',
    driverStory: '/lookback/driver/story',
    user: '/lookback/user',
    userStory: '/lookback/user/story',
  },
  webinappOnly: '/webinapp-only',
  bill: (id: string) => `/bill/${id}`,
  membership: '/membership',
  membershipHistory: '/membership/history',
};

// Constants to avoid duplication
const PAGE_VERIFY_ORDER = 'page.verify_order';
const PAGE_STATISTICS = 'page.statistics';
const PAGE_SUBSCRIPTIONS = 'page.subscriptions';

// Direct mapping from ROUTES to page keys
export const ROUTE_TITLE_KEY = {
  [ROUTES.home]: 'page.home',
  [ROUTES.newOrder]: 'page.new_order',
  [ROUTES.nationwide]: 'page.nationwide',
  [ROUTES.truck]: 'page.truck',
  [ROUTES.rental]: 'page.ev_rental',
  [ROUTES.records]: 'page.records',
  [ROUTES.verifyOrder]: PAGE_VERIFY_ORDER,
  [ROUTES.draftOrder]: 'page.draft_order',
  [ROUTES.favoriteDrivers]: 'page.favorite_drivers',
  [ROUTES.balance]: 'page.user_balance',
  [ROUTES.roTool]: 'page.ro_tool',
  [ROUTES.roSme]: 'page.ro_sme',
  [ROUTES.routeOptimizationPickup]: 'page.route_optimization_pickup',
  [ROUTES.rewards]: 'page.rewards',
  [ROUTES.challenges]: 'page.challenges',
  [ROUTES.news]: 'page.news',
  [ROUTES.statistics]: PAGE_STATISTICS,
  [ROUTES.employees]: 'page.employees',
  [ROUTES.referral]: 'page.referral',
  [ROUTES.warehouse]: 'page.warehouse',
  [ROUTES.helpCenter]: 'page.help',
  [ROUTES.audience]: 'page.audience',
  [ROUTES.profile]: 'page.profile',
  [ROUTES.subscriptions]: PAGE_SUBSCRIPTIONS,
  [ROUTES.membership]: 'page.membership',
  [ROUTES.membershipHistory]: 'page.membership_history',

  // Auth routes
  [ROUTES.auth.login]: 'page.sign-in',
  [ROUTES.auth.signup]: 'page.sign-up',

  // Payment routes
  [ROUTES.payment.transactions]: 'page.history',

  // Dynamic routes patterns
  '/record/[id]': 'page.record_detail',
  '/pay/[id]': PAGE_VERIFY_ORDER,
  '/bill/[id]': 'page.bill',
  '/payment/transaction/[id]': 'page.history',
  '/subscriptions/[id]': PAGE_SUBSCRIPTIONS,
  '/subscriptions/progresses/[id]': PAGE_SUBSCRIPTIONS,
  '/rewards/session/[type]': 'page.rewards',
  '/checkout/[type]/[id]': PAGE_VERIFY_ORDER,

  // Lookback routes
  [ROUTES.lookback.driver]: PAGE_STATISTICS,
  [ROUTES.lookback.driverStory]: PAGE_STATISTICS,
  [ROUTES.lookback.user]: PAGE_STATISTICS,
  [ROUTES.lookback.userStory]: PAGE_STATISTICS,

  // Other routes
  [ROUTES.suspendedAccount]: 'page.profile',
  [ROUTES.webinappOnly]: 'page.home',
  [ROUTES.sentryExamplePage]: 'page.home',
} as const;
